import React from "react";
import { Link } from "react-router-dom";

// Rendu inline : gère **gras** et [texte](url) (liens internes -> Link, externes -> a)
function renderInline(text, keyPrefix) {
  const nodes = [];
  const regex = /(\*\*([^*]+)\*\*)|(\[([^\]]+)\]\(([^)]+)\))/g;
  let lastIndex = 0;
  let idx = 0;
  let m;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > lastIndex) nodes.push(text.slice(lastIndex, m.index));
    if (m[1]) {
      nodes.push(
        <strong key={`${keyPrefix}-b-${idx++}`} className="font-semibold text-neutral-900">
          {m[2]}
        </strong>
      );
    } else if (m[3]) {
      const label = m[4];
      const url = m[5];
      if (url.startsWith("/")) {
        nodes.push(
          <Link
            key={`${keyPrefix}-l-${idx++}`}
            to={url}
            className="font-semibold text-brand underline underline-offset-2 hover:opacity-80"
          >
            {label}
          </Link>
        );
      } else {
        nodes.push(
          <a
            key={`${keyPrefix}-a-${idx++}`}
            href={url}
            target="_blank"
            rel="noreferrer"
            className="font-semibold text-brand underline underline-offset-2 hover:opacity-80"
          >
            {label}
          </a>
        );
      }
    }
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) nodes.push(text.slice(lastIndex));
  return nodes;
}

export function Markdown({ content }) {
  const lines = content.replace(/\r\n/g, "\n").split("\n");
  const blocks = [];
  let para = [];
  let list = [];
  const flushPara = () => {
    if (para.length) {
      blocks.push({ type: "p", text: para.join(" ") });
      para = [];
    }
  };
  const flushList = () => {
    if (list.length) {
      blocks.push({ type: "ul", items: list.slice() });
      list = [];
    }
  };
  for (const raw of lines) {
    const line = raw.trimEnd();
    if (/^###\s+/.test(line)) {
      flushPara();
      flushList();
      blocks.push({ type: "h3", text: line.replace(/^###\s+/, "") });
    } else if (/^##\s+/.test(line)) {
      flushPara();
      flushList();
      blocks.push({ type: "h2", text: line.replace(/^##\s+/, "") });
    } else if (/^[-*]\s+/.test(line)) {
      flushPara();
      list.push(line.replace(/^[-*]\s+/, ""));
    } else if (line.trim() === "") {
      flushPara();
      flushList();
    } else {
      flushList();
      para.push(line.trim());
    }
  }
  flushPara();
  flushList();

  return (
    <div className="space-y-fib-4 text-gr-base">
      {blocks.map((b, i) => {
        if (b.type === "h2")
          return (
            <h2 key={i} className="mt-fib-6 text-gr-xl font-extrabold tracking-tight text-neutral-900 text-balance">
              {renderInline(b.text, `h2${i}`)}
            </h2>
          );
        if (b.type === "h3")
          return (
            <h3 key={i} className="mt-fib-5 text-gr-lg font-bold text-neutral-900">
              {renderInline(b.text, `h3${i}`)}
            </h3>
          );
        if (b.type === "ul")
          return (
            <ul key={i} className="ml-5 list-disc space-y-fib-2 text-neutral-700">
              {b.items.map((it, j) => (
                <li key={j}>{renderInline(it, `li${i}-${j}`)}</li>
              ))}
            </ul>
          );
        return (
          <p key={i} className="text-neutral-700">
            {renderInline(b.text, `p${i}`)}
          </p>
        );
      })}
    </div>
  );
}

export default Markdown;
